<template lang="pug">
    header.header
        button.hamburger.hamburger--3dy(type="button" :class="{ 'is-active': sidebar }" @click="toggleSidebar")
            span.hamburger-box
                span.hamburger-inner
            .mobile-logo.is-visible-touch
                img.is-pulled-left(v-if="logo && logo.id" v-lazy="image" alt="DIVƎRGANCY Models - Logo"  title="DIVƎRGANCY Models" rel="noopener")
                img.is-pulled-left(v-else src="@/assets/city-offer-logo.svg" alt="DIVƎRGANCY Models - Logo"  title="DIVƎRGANCY Models")
        .container.is-hidden-touch
            .columns
                .logo-wrapper
                    component(:is="logoWrap" v-bind="logoWrapProps")
                        img#logo.is-pulled-left(v-if="logo && logo.id" v-lazy="image" alt="DIVƎRGANCY Models - Logo"  title="DIVƎRGANCY Models" rel="noopener")
                        img#logo.is-pulled-left(v-else src="@/assets/city-offer-logo.svg" alt="DIVƎRGANCY Models - Logo"  title="DIVƎRGANCY Models")

                .main-menu-wrapper.column
                    nav#main-menu.is-pulled-right(aria-label="Hauptmenü")
                        tree-menu(:items="items" :max-depth="2" :delay="400")
</template>

<script>

// import _ from 'lodash'
import get from 'lodash.get'
import trim from 'lodash.trim'
import cloneDeep from 'lodash.clonedeep'

import { mapGetters, mapMutations } from 'vuex'

import NestedSet from '@/nested-set-lib'

export default {
    name: 'Header',
    computed: {
        logoWrap() {
            let tag = 'span';
            if (this.$route.path !== '/') {
                tag = 'a';
            }
            return tag;
        },
        logoWrapProps() {
            let props = {};
            if (this.$route.path !== '/') {
                props = { href: '/' };
            }
            return props;
        },
        items() {
            const menu = this.menus.find(menu => menu.key === 'header-menu')
            let items = get(menu, 'menuItems') || []
            items = cloneDeep(items)

            if (items.length) {
                return NestedSet.createTree(items)
            }

            return items
        },
        image() {
            const storageRoute = trim(`${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`, '/')

            const fit = 'fit=fill&w=350&h=150'

            let width = this.logo.width
            let height = this.logo.height

            return {
                src: `${storageRoute}/images/${this.logo.id}/${this.logo.name}?${fit}`,
                error: `${storageRoute}/images/${this.logo.id}/${this.logo.name}?${fit}&preview=greyscale`,
                loading: `${storageRoute}/images/${this.logo.id}/${this.logo.name}?${fit}&preview=blur`,
                width,
                height,
            }
        },
        ...mapGetters({
            logo: 'logo',
            menus: 'menus',
            sidebar: 'sidebar',
        })
    },
    methods: {
        toggleSidebar() {
            this.updateSidebarVisibility(! this.sidebar)
        },
        ...mapMutations({
            updateSidebarVisibility: 'updateSidebarVisibility',
        })
    },
}
</script>

<style lang="sass" scoped>

    @import "~bulma/sass/utilities/mixins"
    @import '~@/assets/sass/variables'


    header
        // padding-top: 50px
        // padding-bottom: 50px
        #logo
            height: 155px
            max-width: 400px
        .hamburger
            height: 100px
            outline: none
            +desktop
                display: none
            .hamburger-inner
                background-color: $primary
                &:before
                    background-color: $primary
                &:after
                    background-color: $primary

        .container
            margin-top: 0.75rem
            height: 150px
            .columns
                height: 100%
                align-items: center
                .logo-wrapper
                    display: flex
                    justify-content: center
                    flex-direction: column
                    position: absolute
                    height: 80%
                    left: 0
                    top: 0
                .main-menu-wrapper.column
                    display: flex
                    justify-content: flex-end
                    a.search
                        height: 54px
                        width: 54px
                        color: $secondary
                        &:hover
                            background-color: $secondary
                            color: #fff

        .main-menu-wrapper
            padding-bottom: 0
            .navbar-item

            #main-menu
                z-index: 10
                &::v-deep
                    ul
                        &.tree-menu
                            & > li
                                transition: background-color .3s ease
                                &:not(.full-width)
                                    position: relative
                                & > .tree-item a
                                    text-decoration: none
                                    font-weight: 800
                                    text-transform: uppercase
                                    color: $primary
                                    padding: 15px
                                    display: inline-block
                                    transition: color .3s ease
                                &.hover
                                    background-color: $primary
                                    & > .tree-item a
                                        color: #fff
                                li
                                    // padding: 0 9px
                                    width: 100%
                                    background-color: $primary
                                    & > .tree-item a
                                        font-weight: normal
                                        color: #fff
                                        display: block
                                        max-width: 300px
                                        overflow: hidden
                                        text-overflow: ellipsis
                                        white-space: nowrap
                                        &:before
                                            font-family: 'Font Awesome 5 Free' !important
                                            speak: none
                                            font-weight: 900
                                            content: '\f054'
                                            color: #fff
                                            padding-right: 6px
                                            transition: color .3s ease
                                            display: none
                                        .svg-inline--fa
                                            margin-right: 6px
                                    &.hover
                                        background-color: lighten($primary, 10%)
                                        & > .tree-item a
                                            color: #fff
                                            &:before
                                                color: $secondary
                    & > ul
                        &.tree-menu
                            & > li
                                // padding: 0 9px 33px 9px
                                display: inline-block
                                & > .tree-item a
                                    padding: 15px 24px 28px 24px
                                    border-bottom: 5px solid transparent
                                    &.router-link-exact-active
                                        color: $secondary
                                        border-bottom: 5px solid $secondary
                                &.hover > .tree-item a.router-link-exact-active
                                    color: #fff
                                & > ul
                                    &.tree-menu
                                        position: absolute
                                        left: 0
                                        top: 100%
                                        display: flex
                                        flex-direction: column
                                        min-width: 200px
                                        box-shadow: 0px 5px 10px 0px rgba(0,0,0,0.3)
                                        &.full-width
                                            width: 100%
                                            columns: 3
                                            column-gap: 0
                                            display: block
                                            +widescreen
                                                columns: 4
                            ul ul
                                min-width: 200px
                                margin-bottom: 9px
                                position: absolute
                                right: 100%
                                top: 0
                                // box-shadow: 0px 5px 10px 0px rgba(0,0,0,0.3)
                                li > .tree-item a
                                    // padding: 10px 15px
                                    // font-size: .8rem
                                    // &:before
                                    //     font-size: 0.5rem
                                    //     position: relative
                                    //     top: -1px

                    .show-enter-active, .show-leave-active
                        transition: opacity 0.3s ease, transform 0.3s ease
                        transform-origin: left center
                    .show-enter, .show-leave-to
                        opacity: 0
                        transform: translateY(6px)
    .mobile-logo
        position: absolute
        right: 8px
        top: 8px
        // padding-left: 70px
        img
            height: 80px
</style>
